export default "__VITE_ASSET__C_TRL8BA__"